import { useState } from "react";
import {
  Br,
  Cut,
  Line,
  Printer,
  Text,
  Row,
  Image,
  Barcode,
  QRCode,
  render,
  Cashdraw,
} from "react-thermal-printer";

export const TestPrint = () => {
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [baseOrderResponse, setBaseOrderResponse] = useState([]);
  const [baseDetails, setBaseDetails] = useState({
    appliedCoupon: "null",
    appliedOffer: null,
    couponRefId: "null",
    offerRefId: null,
    subTotal: 485.38,
    cgst: 13.81,
    sgst: 13.81,
    igst: 27.62,
    tax: 27.62,
    handlingCharges: 0,
    shippingCharges: 0,
    grandTotal: 513,
    paymentMethod: "COD",
    loyaltyPoints: null,
  });
  const [gstBreakupDetails, setGstBreakupDetails] = useState([
    {
      taxableAmt: 104,
      cgst: 0,
      sgst: 0,
      cess: null,
      totalAmt: 104,
      type: "No Gst Slab",
    },
    {
      taxableAmt: 276.191,
      cgst: 6.9045,
      sgst: 6.9045,
      cess: null,
      totalAmt: 290,
      type: "2.5 cgst and 2.5 sgst slab",
    },
    {
      taxableAmt: 106.25,
      cgst: 6.375,
      sgst: 6.375,
      cess: null,
      totalAmt: 119,
      type: "6 cgst and 6 sgst slab",
    },
    {
      taxableAmt: null,
      cgst: null,
      sgst: null,
      cess: null,
      totalAmt: null,
      type: null,
    },
    {
      taxableAmt: null,
      cgst: null,
      sgst: null,
      cess: null,
      totalAmt: null,
      type: null,
    },
  ]);
  const [orderDetails, setOrderDetails] = useState({
    appliedCoupon: "null",
    appliedOffer: null,
    couponRefId: "null",
    offerRefId: null,
    subTotal: 485.38,
    cgst: 13.81,
    sgst: 13.81,
    igst: 27.62,
    tax: 27.62,
    handlingCharges: 0,
    shippingCharges: 0,
    grandTotal: 513,
    paymentMethod: "COD",
    loyaltyPoints: null,
  });
  const [orgDetails, setOrgDetails] = useState([]);
  const [branchDetails, setbranchDetails] = useState([]);
  const [noGst, setNoGst] = useState([
    {
      itemNo: null,
      skuCode: null,
      quantityUnits: null,
      weight: 0,
      weightUOM: null,
      volume: 0,
      volumeUOM: null,
      expirationDate: null,
      voidedOn: null,
      voidedBy: null,
      productId: "",
      gtin: "8906020589377",
      productName: "iD Tender Coconut Large",
      size: null,
      unit: null,
      sellerName: null,
      mrp: 55,
      sellingPrice: 55,
      quantity: 1,
      status: null,
      quantityReceived: 0,
      quantityOutstanding: 0,
      lastInward: 0,
      batchNumber: null,
      inwardedOn: null,
      inwardedBy: null,
      discountPrice: 0,
      subTotal: 55,
      productImage: null,
      productGST: 0,
      productOtherTax: 0,
      igst: 0,
      cgst: 0,
      sgst: 0,
      hsnCode: "22029090",
      createdDate: null,
      createdBy: null,
      modifiedDate: null,
      modifiedBy: null,
    },
    {
      itemNo: null,
      skuCode: null,
      quantityUnits: null,
      weight: 0,
      weightUOM: null,
      volume: 0,
      volumeUOM: null,
      expirationDate: null,
      voidedOn: null,
      voidedBy: null,
      productId: "",
      gtin: "8906020589384",
      productName: "iD Tender Coconut Medium",
      size: null,
      unit: null,
      sellerName: null,
      mrp: 49,
      sellingPrice: 49,
      quantity: 1,
      status: null,
      quantityReceived: 0,
      quantityOutstanding: 0,
      lastInward: 0,
      batchNumber: null,
      inwardedOn: null,
      inwardedBy: null,
      discountPrice: 0,
      subTotal: 49,
      productImage: null,
      productGST: 0,
      productOtherTax: 0,
      igst: 0,
      cgst: 0,
      sgst: 0,
      hsnCode: "22029090",
      createdDate: null,
      createdBy: null,
      modifiedDate: null,
      modifiedBy: null,
    },
  ]);
  const [gst1, setGst1] = useState([
    {
      itemNo: null,
      skuCode: null,
      quantityUnits: null,
      weight: 0,
      weightUOM: null,
      volume: 0,
      volumeUOM: null,
      expirationDate: null,
      voidedOn: null,
      voidedBy: null,
      productId: "195969a4-f666-480c-97d4-855875cb97f3",
      gtin: "8906132830060",
      productName: "Parsley",
      size: null,
      unit: null,
      sellerName: null,
      mrp: 115,
      sellingPrice: 115,
      quantity: 1,
      status: null,
      quantityReceived: 0,
      quantityOutstanding: 0,
      lastInward: 0,
      batchNumber: null,
      inwardedOn: null,
      inwardedBy: null,
      discountPrice: 0,
      subTotal: 115,
      productImage: null,
      productGST: 0,
      productOtherTax: 0,
      igst: 5,
      cgst: 2.5,
      sgst: 2.5,
      hsnCode: "07129090",
      createdDate: null,
      createdBy: null,
      modifiedDate: null,
      modifiedBy: null,
    },
    {
      itemNo: null,
      skuCode: null,
      quantityUnits: null,
      weight: 0,
      weightUOM: null,
      volume: 0,
      volumeUOM: null,
      expirationDate: null,
      voidedOn: null,
      voidedBy: null,
      productId: "195969a4-f666-480c-97d4-855875cb97f3",
      gtin: "8906132830060",
      productName: "Parsley",
      size: null,
      unit: null,
      sellerName: null,
      mrp: 115,
      sellingPrice: 115,
      quantity: 1,
      status: null,
      quantityReceived: 0,
      quantityOutstanding: 0,
      lastInward: 0,
      batchNumber: null,
      inwardedOn: null,
      inwardedBy: null,
      discountPrice: 0,
      subTotal: 115,
      productImage: null,
      productGST: 0,
      productOtherTax: 0,
      igst: 5,
      cgst: 2.5,
      sgst: 2.5,
      hsnCode: "07129090",
      createdDate: null,
      createdBy: null,
      modifiedDate: null,
      modifiedBy: null,
    },
  ]);
  const [gst2, setGst2] = useState([
    {
      itemNo: null,
      skuCode: null,
      quantityUnits: null,
      weight: 0,
      weightUOM: null,
      volume: 0,
      volumeUOM: null,
      expirationDate: null,
      voidedOn: null,
      voidedBy: null,
      productId: "968432b2-c8e7-4070-9f55-099a9db83f92",
      gtin: "8906065940027",
      productName: "Water Chestnut  565 Gms",
      size: null,
      unit: null,
      sellerName: null,
      mrp: 119,
      sellingPrice: 119,
      quantity: 1,
      status: null,
      quantityReceived: 0,
      quantityOutstanding: 0,
      lastInward: 0,
      batchNumber: null,
      inwardedOn: null,
      inwardedBy: null,
      discountPrice: 0,
      subTotal: 119,
      productImage: null,
      productGST: 0,
      productOtherTax: 0,
      igst: 12,
      cgst: 6,
      sgst: 6,
      hsnCode: "20019000",
      createdDate: null,
      createdBy: null,
      modifiedDate: null,
      modifiedBy: null,
    },
  ]);
  const [gst3, setGst3] = useState([]);
  const [loggedUser, setLoggedUser] = useState("Satish Twinleaves");
  const [date, setDate] = useState("7/4/2023, 1:23:40 PM");
  const [invoiceId, setInvoiceId] = useState("OI2307042221");
  const [retailDetails, setRetailDetails] = useState({
    displayName: "AMMA SUPER STORE",
    address: {
      id: 122,
      name: "AMMA SUPER STORE",
      addressLine1: "addressLine1",
      addressLine2: "NO1,APEX COLONY",
      country: "India",
      state: "TAMIL NADU",
      city: "PALLIPALAYAM",
      pincode: "123456",
      defaultShipping: true,
      defaultBilling: true,
      active: true,
      enabled: true,
      createdBy: "pulkit",
      updatedBy: "pulkit",
      created: "2023-07-01T10:56:29.870349",
      updated: "2023-07-01T10:59:27.51441",
      entityId: "RLC_54",
      entityType: "BRANCH",
      mobileNumber: "9876543210",
      defaultAddress: true,
    },
    gst: "33ABSFA6271C1ZI",
    contacts: [
      {
        contactId: "2023070110591700054",
        name: "Test",
        phoneNo: "1234567890",
        email: "p.d@g.com",
        createdBy: "user",
        updatedBy: "user",
        active: true,
        enabled: true,
        entityId: "RLC_54",
        entityType: "BRANCH",
        source: "RMS",
        contactType: "SUPPORT",
        created: "2023-07-01T10:59:17.806501",
        updated: "2023-07-01T10:59:17.806513",
      },
    ],
  });
  const [isData, setIsData] = useState(false);
  const [portData, setPortData] = useState(null);
  const [reprintData, setReprintData] = useState(false);

  const [locationData, setLocationData] = useState(
    JSON.parse(localStorage.getItem("locationData"))
  );
  const [printerConfig, setPrinterConfig] = useState(
    JSON.parse(localStorage.getItem("printerConfig"))
  );
  const printSerial = async () => {
    const data = await render(
      <Printer type="epson">
        <Text>Hello World</Text>
      </Printer>
    );

    const port = await window.navigator.serial.requestPort();
    await port.open({ baudRate: 9600 });

    const writer = port.writable?.getWriter();
    if (writer != null) {
      await writer.write(new TextEncoder().encode("Hello, World!\n"));
      writer.releaseLock();
    }
  };

  const printUSB = async () => {
    try {
      const data = await render(
        <Printer type="epson" width={printerConfig?.printer === "Posiflex" ? 42 : 45}>
          {/* <Text align="center">Evernest Private Limited</Text>
            <Text align="center">Level 4, No 3, Narayani Arcade</Text>
            <Text align="center">ITPL Main Rd, Kundalahalli</Text>
            <Text align="center">Bengaluru, Karnataka 560037</Text>
            <Text align="center">Phone: +91 7558890052</Text>
            <Text align="center">GSTIN: 27AACCA8432H1ZQ</Text> */}

          <Line />
          <Text align="center" bold={true}>
            Items sold cannot be returned or refunded
          </Text>
          <Line />
          {/* <Text align="center">{retailDetails?.address?.addressLine1 || "AddressLine1"}</Text>

          <Text align="center">{retailDetails?.address?.addressLine2 || "AddressLine2"}</Text>

          <Text align="center">
            Phone:{" "}
            {`${
              retailDetails?.contacts?.map(({ phoneNo }) => phoneNo).join(" / ") || "PhoneNo"
            } GSTIN: ${retailDetails?.gst || "GSTIN"}`}
          </Text>

          <Line />
          <Text align="center" bold={true}>
            TAX INVOICE
          </Text>
          <Line />
          <Row left={`Bill No ${invoiceId}`} right={loggedUser} />
          <Row left={date.toLocaleString()} right={baseDetails.paymentMethod} />
          <Line />
          <Text bold={true}>{"HSN   Particulars".padEnd(42)}</Text>
          <Text bold={true}>{"             Qty    MRP     Rate     Value"}</Text>
          <Line />
          {noGst?.length && (
            <>
              <Text bold={true}>{"          No CGST + No SGST"}</Text>
              {noGst?.map((e) => (
                <>
                  <Text>{`${e.hsnCode.slice(0, 4).padEnd(4)}  ${e.productName
                    .slice(0, 36)
                    .padEnd(36)}`}</Text>
                  <Text>{`             ${e.quantity.toString().slice(0, 3).padStart(3)}${e.mrp
                    .toString()
                    .slice(0, 7)
                    .padStart(7)}${e.sellingPrice.toString().slice(0, 9).padStart(9)} ${e.subTotal
                    .toString()
                    .slice(0, 9)
                    .padStart(9)}`}</Text>
                </>
              ))}
            </>
          )}
          {gst1?.length && (
            <>
              <Text bold={true}>{"          2.5% CGST and 2.5% SGST"}</Text>
              {gst1?.map((e) => (
                <>
                  <Text>{`${e.hsnCode.slice(0, 4).padEnd(4)}  ${e.productName
                    .slice(0, 36)
                    .padEnd(36)}`}</Text>
                  <Text>{`             ${e.quantity.toString().slice(0, 3).padStart(3)}${e.mrp
                    .toString()
                    .slice(0, 7)
                    .padStart(7)}${e.sellingPrice.toString().slice(0, 9).padStart(9)} ${e.subTotal
                    .toString()
                    .slice(0, 9)
                    .padStart(9)}`}</Text>
                </>
              ))}
            </>
          )}
          {gst2?.length && (
            <>
              <Text bold={true}>{"          6% CGST and 6% SGST"}</Text>
              {gst2?.map((e) => (
                <>
                  <Text>{`${e.hsnCode.slice(0, 4).padEnd(4)}  ${e.productName
                    .slice(0, 36)
                    .padEnd(36)}`}</Text>
                  <Text>{`             ${e.quantity.toString().slice(0, 3).padStart(3)}${e.mrp
                    .toString()
                    .slice(0, 7)
                    .padStart(7)}${e.sellingPrice.toString().slice(0, 9).padStart(9)} ${e.subTotal
                    .toString()
                    .slice(0, 9)
                    .padStart(9)}`}</Text>
                </>
              ))}
            </>
          )}
          {gst3?.length && (
            <>
              <Text bold={true}>{"          9% CGST and 9% SGST"}</Text>
              {gst3?.map((e) => (
                <>
                  <Text>{`${e.hsnCode.slice(0, 4).padEnd(4)}  ${e.productName
                    .slice(0, 36)
                    .padEnd(36)}`}</Text>
                  <Text>{`             ${e.quantity.toString().slice(0, 3).padStart(3)}${e.mrp
                    .toString()
                    .slice(0, 7)
                    .padStart(7)}${e.sellingPrice.toString().slice(0, 9).padStart(9)} ${e.subTotal
                    .toString()
                    .slice(0, 9)
                    .padStart(9)}`}</Text>
                </>
              ))}
            </>
          )}
          <Line />
          <Row
            left={<Text bold={true}>{`Total Items: ${totalQuantity}`}</Text>}
            right={<Text bold={true}>{`Total Amount: ${orderDetails.grandTotal}`}</Text>}
          />
          <Line />
          <Text align="center" bold={true}>
            {"<--------- GST Breakup Details --------->"}
          </Text>
          <Line />
          <Text bold={true}>{"SNo   TaxableAmt    CGST   SGST   TotalAmt"}</Text>
          <Line />
          {gstBreakupDetails?.length &&
            gstBreakupDetails
              ?.filter((item) => item.taxableAmt != null)
              ?.map((e, i) => (
                <Text>{`${i + 1}     ${e.taxableAmt
                  .toFixed(2)
                  .toString()
                  .slice(0, 10)
                  .padEnd(10)}  ${e.cgst.toFixed(2).toString().slice(0, 6).padStart(6)}${e.sgst
                  .toFixed(2)
                  .toString()
                  .slice(0, 7)
                  .padStart(7)}${
                  e.totalAmt ? e.totalAmt.toFixed(2).toString().slice(0, 11).padStart(11) : "---"
                }`}</Text>
              ))}
          <Line />
          <Row
            left={<Text bold={true}>Total Savings</Text>}
            right={<Text bold={true}>{`${orderDetails.totalSavings || 0}`}</Text>}
          />
          <Line />
          <Text align="center">Thank you for shopping with us!</Text>
          <Text align="center">@Powered by Pallet</Text>
          <Cashdraw pin="2pin" /> */}
          {/* <Text>text</Text>
          <Text>fragment is {"allowed"}</Text>
          <Text align="center">center text</Text>
          <Text align="right">right text</Text>
          <Text bold={true}>bold text</Text>
          <Text underline="1dot-thick">underline text</Text>
          <Text invert={true}>invert text</Text>
          <Text size={{ width: 2, height: 2 }}>big size text</Text>
          <Br />
          <Row left="left" right="right" />
          <Row left="left" right="right" gap={2} />
          <Row left={<Text>left</Text>} right="right" />
          <Row left={<Text>left</Text>} right="very very long text will be multi line placed." />
          <Br />
          <Line />
          <Line character="=" />
          <Br />
          <Barcode type="UPC-A" content="111111111111" />
          <Barcode type="CODE39" content="A000$" />
          <Barcode align="center" type="UPC-A" content="111111111111" />
          <Br />
          <QRCode content="https://github.com/seokju-na/react-thermal-printer" />
          <QRCode align="center" content="https://github.com/seokju-na/react-thermal-printer" />
          <Br /> */}
          <Cut />
        </Printer>
      );
      const findOpenedDevice = async () => {
        const devices = await navigator.usb.getDevices();
        return devices.find((d) => d.opened);
      };

      const openedDevice = await findOpenedDevice();

      const usbDevice = openedDevice || (await navigator.usb.requestDevice({ filters: [] }));
      openedDevice ? console.log("Port already open") : await usbDevice.open();
      // const usbDevice = await navigator.usb.requestDevice({ filters: [{ vendorId: 3386 }] });
      // const usbDevice =  {

      // }

      if (usbDevice.configuration === null) {
        await usbDevice.selectConfiguration(1);
      }
      await usbDevice.claimInterface(usbDevice.configuration.interfaces[0].interfaceNumber);

      await usbDevice.transferOut(
        usbDevice.configuration.interfaces[0].alternate.endpoints.find(
          (obj) => obj.direction === "out"
        ).endpointNumber,
        data
      );
      //   await usbDevice.close();

      // You can now send commands to the printer
    } catch (error) {
      console.error("Error connecting to the printer: ", error);
    }
  };

  return (
    <div>
      <button onClick={printSerial}>Print Serial</button>
      <button onClick={printUSB}>Print USB</button>
    </div>
  );
};
